import { SpacingScale } from './SpacingScale';
import { ComponentShowcase } from './ComponentShowcase';
import { ItemDaDocumentacao } from './ItemDaDocumentacao';
import { cn } from '@/nucleo/utilitarios';

const SPACING_ITEMS = [
  { name: '0.5', className: 'gap-0.5 / p-0.5', valuePx: '2px', usage: 'Espaço mínimo' },
  { name: '1', className: 'gap-1 / p-1', valuePx: '4px', usage: 'Espaço dentro do ícone' },
  {
    name: '1.5',
    className: 'gap-1.5 / p-1.5',
    valuePx: '6px',
    usage: 'Espaço entre linhas densas',
  },
  { name: '2', className: 'gap-2 / p-2', valuePx: '8px', usage: 'Espaço padrão entre itens' },
  {
    name: '3',
    className: 'gap-3 / p-3',
    valuePx: '12px',
    usage: 'Margem interna de cartão compacto',
  },
  {
    name: '4',
    className: 'gap-4 / p-4',
    valuePx: '16px',
    usage: 'Espaço entre seções, margem interna padrão',
  },
  {
    name: '5',
    className: 'gap-5 / p-5',
    valuePx: '20px',
    usage: 'Margem interna de cartão e de amostra',
  },
  {
    name: '6',
    className: 'gap-6 / p-6',
    valuePx: '24px',
    usage: 'Margem interna de CardContent e de seção',
  },
  { name: '8', className: 'gap-8 / p-8', valuePx: '32px', usage: 'Separação entre blocos' },
  {
    name: '12',
    className: 'gap-12 / p-12',
    valuePx: '48px',
    usage: 'Margem interna de área vazia',
  },
  { name: '16', className: 'gap-16 / p-16', valuePx: '64px', usage: 'EmptyState e Spinner grande' },
];

const RADIUS_ITEMS = [
  { name: 'sm', class: 'rounded-sm', value: 'calc(0.5rem - 4px)', preview: 'rounded-sm' },
  { name: 'md', class: 'rounded-md', value: 'calc(0.5rem - 2px)', preview: 'rounded-md' },
  { name: 'lg (base)', class: 'rounded-lg', value: '0.5rem', preview: 'rounded-lg' },
  { name: 'xl', class: 'rounded-xl', value: '0.75rem', preview: 'rounded-xl' },
  { name: '2xl', class: 'rounded-2xl', value: '1rem', preview: 'rounded-2xl' },
  { name: 'full', class: 'rounded-full', value: '9999px', preview: 'rounded-full' },
];

const BREAKPOINTS = [
  {
    name: 'Celular',
    width: '< 640px',
    class: 'padrão',
    desc: 'Coluna única, gavetas, grade de 1 coluna',
  },
  { name: 'sm', width: '≥ 640px', class: 'sm:', desc: 'Campos lado a lado, 2 colunas' },
  { name: 'md', width: '≥ 768px', class: 'md:', desc: 'Barra lateral fixa, 2 a 3 colunas' },
  { name: 'lg', width: '≥ 1024px', class: 'lg:', desc: 'Várias colunas, grades expandidas' },
  { name: '2xl', width: '≥ 1400px', class: '2xl:', desc: 'Largura máxima do conteúdo (1400 px)' },
];

export function EspacamentoTab() {
  return (
    <div className="space-y-8">
      <ItemDaDocumentacao id="espacamento-escala">
        <section>
          <h3 className="text-lg font-semibold mb-1">Escala de espaçamento</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Unidade base: 4 px — escala padrão do Tailwind
          </p>
          <div className="rounded-xl border border-border bg-card p-5">
            <SpacingScale items={SPACING_ITEMS} />
          </div>
        </section>
      </ItemDaDocumentacao>

      <ComponentShowcase
        id="espacamento-arredondamento"
        title="Arredondamento"
        description="Escala de arredondamento — var(--radius) = 0.5rem"
        code={`// Cartões e abas
<Card className="rounded-2xl" />

// Campos e botões
<Input className="rounded-xl" />

// Selos
<Badge className="rounded-full" />`}
      >
        <div className="flex flex-wrap gap-4">
          {RADIUS_ITEMS.map((r) => (
            <div key={r.name} className="flex flex-col items-center gap-2">
              <div className={cn('h-16 w-16 border-2 border-primary bg-primary/10', r.class)} />
              <div className="text-center">
                <p className="text-xs font-mono font-semibold">{r.class}</p>
                <p className="text-[10px] text-muted-foreground">{r.value}</p>
              </div>
            </div>
          ))}
        </div>
      </ComponentShowcase>

      <ComponentShowcase
        id="espacamento-pontos-de-quebra"
        title="Pontos de quebra"
        description="A base é o celular, em coluna única; cada ponto de quebra amplia"
        code={`// Grade responsiva
<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
  {items.map(item => <Card key={item.id} />)}
</div>

// Conteúdo centralizado
<div className="container mx-auto max-w-[1400px] px-4 sm:px-6">`}
      >
        <div className="w-full space-y-2">
          {BREAKPOINTS.map((bp) => (
            <div
              key={bp.name}
              className="flex items-center gap-4 py-1.5 border-b border-border/30 last:border-0"
            >
              <span className="text-sm font-semibold w-16 shrink-0">{bp.name}</span>
              <span className="text-xs font-mono text-muted-foreground w-20 shrink-0">
                {bp.width}
              </span>
              <span className="text-xs font-mono text-link w-12 shrink-0">{bp.class}</span>
              <span className="text-xs text-muted-foreground">{bp.desc}</span>
            </div>
          ))}
        </div>
      </ComponentShowcase>
    </div>
  );
}
